import { useEffect, useRef, useState } from "react";

const useDebouncedValue = (value, delay = 300) => {
  const [debounced, setDebounced] = useState(value);
  const latestValueRef = useRef(value);

  useEffect(() => {
    latestValueRef.current = value;
  }, [value]);

  useEffect(() => {
    const handle = setTimeout(() => {
      setDebounced(latestValueRef.current);
    }, delay);

    return () => {
      clearTimeout(handle);
    };
  }, [delay, value]);

  return debounced;
};

export default useDebouncedValue;
